import { Box, ButtonGroup, Icon, VStack } from '@chakra-ui/react';
import { isGroup } from '@utils/menu.utils';
import { useIntl } from 'react-intl';

import { MenuItemOption, MenuItemOptionIcons, MenuItemsIcons } from '@/types/menu.types';

import { ButtonBar } from '../../ui/buttonBar';
import MenuList from './MenuList';

interface MenuIconBarProps {
  menuItems: MenuItemsIcons;
  depth: number;
  selectedOptions: string[];
  handleClick: (option: string, value: MenuItemOption | MenuItemOptionIcons | undefined, depth: number) => void;
  listButtonWidth?: string;
}

export const MenuIconBar = ({
  menuItems,
  depth,
  selectedOptions,
  handleClick,
  listButtonWidth,
}: Readonly<MenuIconBarProps>) => {
  const { formatMessage } = useIntl();
  return (
    <Box position="relative" gap={0} paddingBottom={0.25} paddingTop={0.25}>
      <Box position="absolute" className="button-wrapper" backgroundColor="neutral.black" />
      <ButtonGroup flexDir="column" gap={0.25} width="100%">
        {Object.entries(menuItems).map(([key, value]) => {
          if (!isGroup(value)) {
            const isSelectedOption = selectedOptions[depth] === key;
            const { subMenuItems, onAction, label, icon, isDisabled, isActive, isHidden } = value;
            return (
              !isHidden && (
                <Box key={key} gap={0} width="100%" position="relative">
                  <ButtonBar.Root
                    aria-label={formatMessage({ id: label })}
                    data-active={(!subMenuItems && !!onAction && isSelectedOption) || isActive}
                    data-selected={!!subMenuItems && isSelectedOption}
                    disabled={isDisabled}
                    tooltipPlacement="right"
                    notchPlacement="bottom-right"
                    onClick={() => handleClick(key, value, depth)}
                  >
                    <ButtonBar.Control>
                      <Icon as={icon} boxSize="40px" />
                    </ButtonBar.Control>
                  </ButtonBar.Root>
                  {key === selectedOptions[depth] && subMenuItems && (
                    <VStack position="absolute" left="74px" top="-2px" gap={0}>
                      <MenuList
                        menuItems={subMenuItems}
                        depth={depth + 1}
                        selectedOptions={selectedOptions}
                        handleClick={handleClick}
                        parentLabel={menuItems[selectedOptions[depth]].label}
                        buttonWidth={listButtonWidth}
                      />
                    </VStack>
                  )}
                </Box>
              )
            );
          }
        })}
      </ButtonGroup>
    </Box>
  );
};
